import { useQuery } from '@tanstack/react-query';
import { RolesApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useRolesControllerFindAllRolesQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['rolesControllerFindAllRoles', accessControlScope, args],
        queryFn: async () => {
            const api = new RolesApi(accessControlConfig);
            return api.rolesControllerFindAllRoles(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useRolesControllerFindAllRolesQuery.js.map